
<ng-container *ngIf="loadingService.loading">
  <div class="ProcessV2">
    <div [ngClass]="loadingService.brandClass"></div>
  </div>
</ng-container>
<ng-container *ngIf="popupService.showing">
  <div class="popup-wrapper">
    <div class="popup-container">
      <div class="panel-wrapper popup-panel">
        <div class="panel-header {{loadingService.brandClass}}">
          <div class="popup-title">
            <p *ngIf="!popupService.french">This time is unavailable</p>
            <p *ngIf="popupService.french">Cette plage horaire n'est pas disponible</p>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="popupService.hide();">
              <path d="M1.83927 0.300126C1.63762 0.10537 1.36755 -0.00239558 1.08722 4.04171e-05C0.806885 0.00247642 0.538727 0.114919 0.340495 0.31315C0.142264 0.511382 0.0298214 0.77954 0.0273854 1.05987C0.0249494 1.3402 0.132715 1.61027 0.327471 1.81192L6.50188 7.98633L0.326402 14.1607C0.224286 14.2594 0.142835 14.3773 0.0868014 14.5078C0.0307677 14.6382 0.00127398 14.7785 4.03684e-05 14.9205C-0.00119325 15.0624 0.0258581 15.2032 0.0796165 15.3346C0.133375 15.466 0.212763 15.5854 0.31315 15.6858C0.413536 15.7862 0.53291 15.8656 0.664306 15.9193C0.795703 15.9731 0.936489 16.0001 1.07845 15.9989C1.22041 15.9977 1.36071 15.9682 1.49115 15.9121C1.62159 15.8561 1.73957 15.7746 1.8382 15.6725L8.01367 9.49812L14.1881 15.6725C14.3897 15.8673 14.6598 15.975 14.9401 15.9726C15.2205 15.9702 15.4886 15.8577 15.6869 15.6595C15.8851 15.4613 15.9975 15.1931 16 14.9128C16.0024 14.6325 15.8946 14.3624 15.6999 14.1607L9.52547 7.98633L15.6999 1.81192C15.8946 1.61027 16.0024 1.3402 16 1.05987C15.9975 0.77954 15.8851 0.511382 15.6869 0.31315C15.4886 0.114919 15.2205 0.00247642 14.9401 4.04171e-05C14.6598 -0.00239558 14.3897 0.10537 14.1881 0.300126L8.01367 6.47453L1.83927 0.299057V0.300126Z" fill="white" />
            </svg>
          </div>
        </div>
        <div class="panel-body">
          <div class="popup-message">
            <p *ngIf="!popupService.french">Seems like your time slot has been taken. Please select a different time available.</p>
            <p *ngIf="popupService.french">Il semble que cette plage horaire a déjà été prise. Veuillez choisir une autre plage horaire.</p>
          </div>
          <div class="popup-buttons">
            <button type="button" class="btn btn-primary {{loadingService.brandClass}}" (click)="popupService.hide();">
              <ng-container *ngIf="!popupService.french">Select a Different Time</ng-container>
              <ng-container *ngIf="popupService.french">Choisir une autre plage horaire</ng-container>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="before-container-layout">
  <div class="container container-layout">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</div>

